import cx from 'classnames';
import Wrapper from './Wrapper';
import BannerImage from '../../assets/images/BannerImage.png';
import styles from './BrowsePlans.scss';
import PlanInfoCard from './PlanInfoCard';
import PlanBreadcrumb from './PlanBreadcrumb';
import { FAQs } from './FAQs';
import ActionLink from './ActionLink';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectFreemiumFeatures,
  // selectIsUserHaveNotAnyPlan,
  selectPlanList,
  selectUserActivePlanDetails,
  selectUserActivePlanSubscriptionOrderId,
  selectUserActiveSubscriptionPlanPriceId,
  setContactFormDialogOpen,
} from '../../redux/slicers/subscriptionSlicer';
import {
  RECURRING_INTERVAL,
  convertStripeCentsToAmount,
  getPlanRecurringCycle,
  PLAN_TYPE_LABEL,
} from './subscriptionHelper';
import { useUserContext } from '../../contexts/UserContext';
import {
  apiToCancelOrRestoreActiveClientSubscription,
  setClientSubscriptionPlans,
} from '../../api/subscription/subscription';
import { useEffect, useState } from 'react';
import { useInfoDialogaActions } from '../../hooks/useInfoDialogaActions';
import { usePermissionsHandler } from '../../hooks/usePermissions';
import Button from '../../components/Button';
import Switch from '../../components/admin/switch';
import { PERMISSION, PERMISSIONS } from '../../constants/permissionConstants';
import Banner from '../../common/Banner/Banner';
import { PurchasedPacks } from './PurchasedPacks';
import { getPlanRecurringPeriod } from '../../helpers/jsHelper';

export const getPlanButtonText = (activePlan, price, planName, interval) => {
  let name = '';
  const activePrice = activePlan?.plan_details?.[0];

  if (activePrice?.price_stripe_price_id === price?.stripe_price_id) {
    name = 'Current plan';
  } else if (
    +activePlan?.recurring_interval >= +price?.recurring_interval &&
    +activePrice?.price_amount > +price?.unit_amount
  ) {
    name = `Downgrade to ${planName} ${interval ? `(${interval})` : ""}`;
  } else {
    name = `Upgrade to ${planName} ${interval ? `(${interval})` : ""}`;
  }

  return name;
};

export const handleFilterFeature = (features = [], planType = false) => {
  if (features && features?.length > 0) {
    let filterList = [];
    if (planType) {
      filterList = features?.filter(
        ({ type }) =>
          type?.toUpperCase() === PLAN_TYPE_LABEL.BOTH ||
          type?.toUpperCase() === PLAN_TYPE_LABEL.TEXTURE
      );
    } else {
      filterList = features?.filter(
        ({ type }) =>
          !type ||
          type?.toUpperCase() === PLAN_TYPE_LABEL.BOTH ||
          type?.toUpperCase() === PLAN_TYPE_LABEL.PRODUCT
      );
    }
    return filterList || [];
  } else {
    return [];
  }
};

function BrowsePlans({
  hideBreadcrumb = false,
  goBack,
  upgradeToSelectedPlan,
  handleManageFlag,
  handleSetState,
  isPackUser = null,
  faqs,
  // interval,
  // isTexturePlan,
}) {
  const { handlePermissionEvent } = usePermissionsHandler();
  const dispatch = useDispatch();
  const { isOldSubscriptionUser } = useUserContext();
  const plans = useSelector(selectPlanList);
  const activePlan = useSelector(selectUserActivePlanDetails);
  const activePlanId = activePlan?.id;
  // const activeOrderId = useSelector(selectUserActivePlanSubscriptionOrderId);
  const activePlanPriceId = useSelector(selectUserActiveSubscriptionPlanPriceId);
  const isActivePlanCancelAtPeriodEnd = activePlan?.cancel_at_period_end;
  const activePlanName = activePlan?.plan_details?.[0]?.plan_name;

  const showFreemiumPlanCard = true; //!userHaveNoPlan;

  const isCurrentPlanIsFreemium =
    isActivePlanCancelAtPeriodEnd === undefined ? true : isActivePlanCancelAtPeriodEnd; //!userHaveNoPlan && isActivePlanCancelAtPeriodEnd;

  const [cancelLoading, setCancelLoading] = useState(false);
  const [recurringInterval, setRecurringInterval] = useState(
    +activePlan?.plan_details?.[0]?.recurring_interval_id || RECURRING_INTERVAL.MONTH
  );
  const [planType, setPlanType] = useState(false); // true - texture, false - product
  const [sortedPlans, setSortedPlans] = useState(plans);

  const freemiumFeatures = useSelector(selectFreemiumFeatures);

  useEffect(() => {
    console.log('DEBUG____sortedPlans_plans', {
      plans,
      sortedPlans,
      planType,
    });
  }, [plans, sortedPlans, planType]);

  useEffect(() => {
    handleSetState({ interval: recurringInterval, isTexturePlan: planType });
  }, []);

  useEffect(() => {
    handleManageFlag({ planType, recurringInterval });
  }, [planType, recurringInterval]);

  useEffect(() => {
    // sorting the plans array based on price
    setSortedPlans(
      [...plans]
        .map((a) => {
          return {
            ...a,
            pricing_details: a?.pricing_details?.filter(
              (item) =>
                // +item?.recurring_interval === +recurringInterval &&
                (planType ? item?.is_textile_plan : !item?.is_textile_plan) &&
                item?.is_default &&
                !item.is_archived &&
                !item?.is_self_serve_plan
            ),
          };
        })
        .filter((a) => !a?.is_upload_limit_plan && !a?.is_ai_imagine_subscription && !a?.is_ai_imagine && !a?.is_ai_imagine_one_time)
        .sort((a, c) => {
          const price1 = a?.pricing_details?.find(
            (item) => +item?.recurring_interval === +recurringInterval
          )?.unit_amount;
          const price2 = c?.pricing_details?.find(
            (item) => +item?.recurring_interval === +recurringInterval
          )?.unit_amount;

          return +price1 - +price2;
        })
    );
  }, [plans, planType, recurringInterval]);

  useEffect(() => {
    if (activePlan) {
      if (!activePlan?.plan_details?.[0]?.is_textile_plan) {
        setPlanType(false);
      } else {
        setPlanType(true);
      }
      setRecurringInterval(+activePlan?.plan_details?.[0]?.recurring_interval_id === 1 ? 1 : 2);
    }
  }, [activePlan]);

  const { openInfoDialog, closeInfoDialog } = useInfoDialogaActions();

  const cancelCurrentPlan = async () => {
    if (!activePlanId) return;
    setCancelLoading(true);
    await apiToCancelOrRestoreActiveClientSubscription({
      id: activePlanId,
      cancel_at_period_end: true,
      successMessage: 'Your plan will be cancelled at the end of its period.',
    })
      .then((response) => {
        if (response?.id) goBack?.();
      })
      .finally(() => {
        closeInfoDialog();
        dispatch(setClientSubscriptionPlans());
        setCancelLoading(false);
      });
  };

  const handleCancelCurrentPlan = () => {
    handlePermissionEvent(
      PERMISSION.SUBSCRIPTION,
      (r) => {
        if (r === undefined) {
          openInfoDialog({
            title: 'Attention!!!',
            description:
              'Are you sure that you want to cancel the current subscription plan? Please be aware that by doing so, you will lose access to all ongoing features and benefits associated with your subscription.',
            cancelButtonText: "Don't cancel",
            buttonText: `Cancel ${activePlanName}`,
            onButtonClick: cancelCurrentPlan,
            open: true,
          });
        }
      },
      PERMISSIONS.SUBSCRIPTION.warningMessage
    )();
  };

  const toggleSwitch = () => {
    setRecurringInterval(
      +recurringInterval === RECURRING_INTERVAL.YEAR
        ? RECURRING_INTERVAL.MONTH
        : RECURRING_INTERVAL.YEAR
    );
  };

  return (
    <Wrapper
      className={'w-100'}
      style={{
        border: 'none',
        borderRadius: 0,
      }}>
      <PlanBreadcrumb
        goBack={goBack}
        hideBack={hideBreadcrumb}
        message={'If you have any questions please reach out to our team '}
        actions={
          <>
            <ActionLink
              title={'Contact us'}
              onClick={() => dispatch(setContactFormDialogOpen(true))}
            />
          </>
        }
      />
      {/* {isPackUser && <PurchasedPacks disabledBuyButton/>} */}
      <Wrapper
        className={'w-100'}
        childrenClassName={'gap-3'}
        style={{
          padding: '16px 0 12px',
          border: 'none',
        }}>
        {!activePlan && (
          <div
            className="d-flex align-items-center justify-content-center gap-2"
            style={{
              padding: '0.25rem',
              borderRadius: '3px',
              backgroundColor: '#fff',
              border: '1px solid #eee',
            }}>
            <Button
              size={'xs'}
              color={!planType ? 'primary' : 'link'}
              onClick={() => setPlanType(false)}
              style={!planType ? {} : { textDecoration: 'none' }}>
              For Product
            </Button>
            <Button
              size={'xs'}
              color={planType ? 'primary' : 'link'}
              onClick={() => setPlanType(true)}
              style={planType ? {} : { textDecoration: 'none' }}>
              For Textiles
            </Button>
          </div>
        )}

        <div className="d-flex align-items-center justify-content-center ms-auto gap-2">
          <label className="layoutSwitch">
            <div className="switch">
              <span
                className={cx(
                  'switchText',
                  recurringInterval === RECURRING_INTERVAL.MONTH ? 'selected' : ''
                )}>
                Billed monthly
              </span>
              <Switch
                containerClassName="mx-2"
                checked={recurringInterval === RECURRING_INTERVAL.MONTH ? false : true}
                onToggle={() => toggleSwitch()}
              />
              <span
                className={cx(
                  'switchText',
                  recurringInterval === RECURRING_INTERVAL.YEAR ? 'selected' : ''
                )}>
                Billed yearly
              </span>
            </div>
          </label>
        </div>

        <Wrapper
          className={'w-100'}
          childrenClassName={'gap-4'}
          style={{
            paddingTop: '29px',
            border: 'none',
            borderRadius: 0,
          }}>
          {sortedPlans?.map((a) => {
            const pricingDetails = a?.pricing_details?.filter(
              (a) => a.recurring_interval === recurringInterval && !a?.is_archived
            );
            if (pricingDetails?.length === 0) return null;
            const features =
              handleFilterFeature(pricingDetails?.[0]?.feature_details, planType) ||
              pricingDetails?.[0]?.feature_details ||
              [];
            const { id, unit_amount, currency, recurring_interval, plan_order } =
              pricingDetails?.[0] || {};
            const isCurrentPlan = activePlanPriceId === id; // activeOrderId === plan_order;

            const amount = `$${convertStripeCentsToAmount(unit_amount)}`;
            const unit = `${currency?.toUpperCase()} / ${getPlanRecurringPeriod(pricingDetails?.[0])
              ?.replace('Per ', '')
              ?.replace('ly', '')
              ?.toLowerCase()}`;
            const buttonText = isOldSubscriptionUser()
              ? 'Buy now'
              : getPlanButtonText(activePlan, pricingDetails?.[0], a.name); //getPlanButtonText(activePlanName, a.name, upgradePlan);

            return (
              <PlanInfoCard
                // samePlan={samePlan}
                key={a?.id}
                isCurrentPlan={isCurrentPlan}
                name={a?.name}
                description={a?.description}
                amount={amount}
                unit={unit}
                buttonText={buttonText}
                features={features}
                allData={a}
                onClick={
                  isCurrentPlan
                    ? () => {}
                    : (priceData, btnText) =>
                        upgradeToSelectedPlan({
                          priceData,
                          buttonText: btnText,
                          planPriceOrderId: plan_order,
                          planPriceAmount: +unit_amount,
                        })
                }
                recommendedProps={{
                  shouldShow: a?.name?.toLowerCase() === 'plus',
                  text: 'imagine.io recommends',
                }}
              />
            );
          })}
          {showFreemiumPlanCard && (
            <PlanInfoCard
              name={'Freemium'}
              loading={cancelLoading}
              isCurrentPlan={isCurrentPlanIsFreemium}
              description={'Our free plan - limited features.'}
              buttonText={!isCurrentPlanIsFreemium ? `Cancel ${activePlanName}` : ''}
              fullWidth={true}
              features={freemiumFeatures}
              hideActions={true}
              isFreemium={true}
              buttonClick={!isCurrentPlanIsFreemium ? handleCancelCurrentPlan : null}
            />
          )}
        </Wrapper>
      </Wrapper>

      <Wrapper
        className={'w-100 mt-4'}
        childrenClassName={'gap-4'}
        style={{
          border: 'none',
          borderRadius: 0,
        }}>
        <FAQs faqs={faqs} />
        <Banner
          title="Need to find out more?"
          description="Our expert team are here to help."
          buttonText="Contact us"
          buttonClick={() => dispatch(setContactFormDialogOpen(true))}
          url={BannerImage}
        />
      </Wrapper>
    </Wrapper>
  );
}

export default BrowsePlans;
